import { Reveal } from "@/components/motion/Reveal";
import { Rich } from "@/components/common/Rich";

// Generic product section: heading left, paragraphs and optional list right.
export const ProductSection = ({ s }) => {
  const List = s.ordered ? "ol" : "ul";
  return (
    <section className="section-y border-t border-line" data-testid={`product-section-${s.id}`}>
      <div className="container-x grid gap-10 lg:grid-cols-12">
        <Reveal className="lg:col-span-5">
          <p className="eyebrow mb-5">{s.eyebrow}</p>
          <h2 className="h-section">{s.title}</h2>
        </Reveal>
        <Reveal delay={0.1} className="space-y-5 lg:col-span-7 lg:pt-10">
          {s.paragraphs?.map((p) => (
            <p key={p} className="text-base leading-relaxed text-muted sm:text-lg">
              <Rich text={p} />
            </p>
          ))}
          {s.list && (
            <List className="divide-y divide-line border-y border-line">
              {s.list.map((item, i) => (
                <li key={item} className="flex gap-4 py-4 text-[15px] text-ink">
                  <span className="font-mono text-[13px] text-accent">{s.ordered ? String(i + 1).padStart(2, "0") : "·"}</span>
                  <span>{item}</span>
                </li>
              ))}
            </List>
          )}
        </Reveal>
      </div>
    </section>
  );
};
